var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M22 2v20H2V2h20zm-9 4.34l-1.41 1.42L14.83 11H6v2h8.83l-3.24 3.24L13 17.66 18.66 12 13 6.34z"}));
}

Arrow.defaultProps = {"width":"24","height":"24","aria-label":"arrow icon","viewBox":"0 0 24 24"};

module.exports = Arrow;

Arrow.default = Arrow;
